import { atom, selector } from 'recoil';
import { LoggedInState } from './LoggedIn';

export const AcademyState = atom({
  key: 'AcademyState',
  default: null
});

export const Academy = selector({
  key: 'Academy',
  get: ({ get }) => {
    const loggedIn = get(LoggedInState)
    const academyState = get(AcademyState)
    if (loggedIn == null) {
      return null
    }
    if (academyState != null  && academyState['refresh']) {
      return null
    }
    // is_admin 은 **운영 학원 여부**다. 예전에는 `type === "A"` 로 위조해서,
    // 모든 학원 관리자가 운영 학원처럼 취급됐다 — 학원 선택기가 보이고 다른
    // 학원을 골라도 서버는 자기 학원 데이터만 주므로 화면이 거짓말을 했다.
    // 서버가 학원 경계를 강제한 뒤로는 그 화면들이 그냥 403 이 된다.
    const isOperator = loggedIn.user.academy_is_admin === true
    let userAcademyState = {
      'id': loggedIn.user.academy_id,
      'name': loggedIn.user.academy_name,
      'type': loggedIn.user.academy_type,
      'is_deleted': false,
      'is_admin': isOperator
    }
    if (isOperator) {
      // 운영 학원만 다른 학원을 골라 볼 수 있다.
      return academyState == null ? userAcademyState : academyState
    } else if (loggedIn.user.type === "A" || loggedIn.user.type === "T") {
      return userAcademyState
    }
  }
});
